export default __webpack_public_path__ + "static/lucy-aa1d3cd21c9da9772d690ace9e4079d0.png";